import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1880f17b")

_pushScopeId("data-v-1880f17b")
const _hoisted_1 = { class: "application-approval-container mt-8 ml-8 mr-8 text-gray-333 mb-20" }
const _hoisted_2 = { class: "flex items-center font-bold text-2xl page-title" }
const _hoisted_3 = { class: "mr-8" }
const _hoisted_4 = { class: "box-application flex justify-between items-baseline" }
const _hoisted_5 = { class: "box-box-application__tab flex flex-wrap pt-3 pb-0" }
const _hoisted_6 = { class: "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row" }
const _hoisted_7 = { class: "box-application__dropdown" }
const _hoisted_8 = { class: "pl-2" }
const _hoisted_9 = { class: "grid box-dropdown-item" }
const _hoisted_10 = { class: "items-center flex justify-end mr-12 mb-5" }
const _hoisted_11 = { class: "flex items-center mb-5" }
const _hoisted_12 = { class: "inline-flex items-center" }
const _hoisted_13 = { class: "mr-datepicker" }
const _hoisted_14 = { class: "flex items-center col-start-2 mb-2" }
const _hoisted_15 = { class: "inline-flex items-center" }
const _hoisted_16 = { class: "mr-3" }
const _hoisted_17 = { class: "items-center flex justify-end mr-12 mb-5" }
const _hoisted_18 = { class: "flex items-center mb-5" }
const _hoisted_19 = { class: "inline-flex items-center" }
const _hoisted_20 = { class: "mr-datepicker" }
const _hoisted_21 = { class: "flex items-center col-start-2 mb-3" }
const _hoisted_22 = { class: "inline-flex items-center" }
const _hoisted_23 = { class: "mr-3" }
const _hoisted_24 = { class: "flex items-center justify-end mr-12 mb-6" }
const _hoisted_25 = { class: "w-64 mb-3 ml-24" }
const _hoisted_26 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_27 = { class: "w-64 mb-3 ml-24" }
const _hoisted_28 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_29 = { class: "w-64 mb-3 ml-24" }
const _hoisted_30 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_31 = { class: "w-64 mb-3 ml-24" }
const _hoisted_32 = { class: "flex items-center justify-end mr-12 mb-3" }
const _hoisted_33 = { class: "w-64 mb-3 ml-24" }
const _hoisted_34 = { class: "flex justify-end mr-12 mb-8" }
const _hoisted_35 = { class: "w-64 mb-3 ml-24" }
const _hoisted_36 = { class: "flex justify-end" }
const _hoisted_37 = { class: "flex items-center mb-4 font-bold justify-between" }
const _hoisted_38 = { class: "flex flex-col" }
const _hoisted_39 = { class: "mr-3 whitespace-normal mb-2" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "flex mt-4" }
const _hoisted_42 = { class: "mr-3" }
const _hoisted_43 = { class: "mb-2 flex justify-around mt-4" }
const _hoisted_44 = { class: "overflow-auto" }
const _hoisted_45 = { class: "flex items-center" }
const _hoisted_46 = { class: "w-1/4 flex justify-center" }
const _hoisted_47 = { class: "box-avatar" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "box-avatar__code font-size-12" }, "0000000", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "box-avatar__title font-size-18" }, "斉藤 亜沙美", -1)
const _hoisted_50 = { class: "flex justify-between font-size-12" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode()
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "一般", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "ml-6 font-size-12" }, "正社員固定A", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-size-12" }, [
    /*#__PURE__*/_createVNode("span", null, "出勤組織"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("span", null, "："),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("span", null, "総務課")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ml-12 font-size-12" }, "総合職")
], -1)
const _hoisted_55 = { class: "flex items-center flex-col" }
const _hoisted_56 = { class: "flex justify-center items-center mt-2" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "mt-icon-warning" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "25",
    height: "22",
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M2.60073 16L12.5 0.911482L22.3993 16H2.60073Z",
      fill: "white",
      stroke: "#B5BA07"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M11.7857 11.3708H13.2137L13.5917 6.58275L13.6617 4.49675H11.3377L11.4077 6.58275L11.7857 11.3708ZM12.4997 15.0948C13.1997 15.0948 13.7317 14.5907 13.7317 13.8627C13.7317 13.1208 13.1997 12.6167 12.4997 12.6167C11.7997 12.6167 11.2677 13.1208 11.2677 13.8627C11.2677 14.5907 11.7857 15.0948 12.4997 15.0948Z",
      fill: "#C0C50B"
    })
  ])
], -1)
const _hoisted_58 = { class: "font-size-16 text-lemon-yellow cursor-pointer" }
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = { class: "font-bold flex justify-between items-center" }
const _hoisted_61 = { class: "box-tag flex justify-end" }
const _hoisted_62 = { class: "box-content__application flex pl-10" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "出勤時間")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "出勤時間")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "退勤時間")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12" }, "出勤場所")
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "打刻実績")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "09 : 00")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "18 : 00")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "font-size-12" })
  ])
], -1)
const _hoisted_65 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "打刻申請")
], -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "08 : 52")
], -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "-- : --")
], -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12" }, "テレワーク")
], -1)
const _hoisted_70 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "打刻実績")
], -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "-- : --")
], -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12 pr-6" }, "18 : 30")
], -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", { class: "font-size-12" }, "テレワーク")
], -1)
const _hoisted_75 = { class: "flex items-center" }
const _hoisted_76 = { class: "mb-2 flex justify-around" }
const _hoisted_77 = { class: "flex justify-center" }
const _hoisted_78 = { class: "mb-2 flex justify-center" }
const _hoisted_79 = { class: "mb-2 flex justify-center flex-col" }
const _hoisted_80 = { class: "box-year flex justify-center" }
const _hoisted_81 = { class: "box-month whitespace-normal flex items-center justify-center" }
const _hoisted_82 = { class: "whitespace-normal font-size-24" }
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "box-day" }, "（木）", -1)
const _hoisted_84 = { class: "box-tag flex justify-center items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Select = _resolveComponent("Select")
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_DropdownItem = _resolveComponent("DropdownItem")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")
  const _component_ModalApplicationApproval = _resolveComponent("ModalApplicationApproval")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('applicationApprovalContent.applicationList')), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("ul", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTabs, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: ["text-center cursor-pointer px-5 py-3 rounded block", _ctx.currentRouter.path.includes(item.path) ? 'active' : ''],
              key: index,
              to: item.path
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", null, [
        _createVNode("div", {
          class: "flex items-center w-200px cursor-pointer mb-6",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDropdownApplication && _ctx.showDropdownApplication(...args)))
        }, [
          _createVNode("span", {
            class: ["font-size-36", 
              _ctx.isSelect ? 'cp-icon-arrow-circle-up' : 'cp-icon-arrow-circle-down'
            ]
          }, null, 2),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t('applicationApprovalContent.hideSearchConditions')), 1)
        ])
      ]),
      _createVNode(_component_DropdownItem, { isSelect: _ctx.isSelect }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('applicationDate')), 1),
            _createVNode("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchParams.applicationDate = $event)),
                  value: 0,
                  name: "applicationDate",
                  type: "radio",
                  class: "h-4 w-4 border-gray-300 mr-3 radio",
                  checked: ""
                }, null, 512), [
                  [_vModelRadio, _ctx.searchParams.applicationDate]
                ]),
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t('monthDesignation')), 1)
              ]),
              _createVNode("div", null, [
                _createVNode(_component_DatePicker, {
                  width: "120",
                  type: "month",
                  disabled: _ctx.searchParams.applicationDate !== 0
                }, null, 8, ["disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("label", _hoisted_15, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchParams.applicationDate = $event)),
                  value: 1,
                  name: "applicationDate",
                  type: "radio",
                  class: "h-4 w-4 border-gray-300 mr-3 text-green-500 radio"
                }, null, 512), [
                  [_vModelRadio, _ctx.searchParams.applicationDate]
                ]),
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t('specifyThePeriod')), 1)
              ]),
              _createVNode("div", null, [
                _createVNode(_component_DatePicker, {
                  width: "240",
                  type: "date",
                  "is-range": "",
                  format: "YYYY/MM/DD",
                  disabled: _ctx.searchParams.applicationDate !== 1
                }, null, 8, ["disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('applicationTargetDate')), 1),
            _createVNode("div", _hoisted_18, [
              _createVNode("label", _hoisted_19, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchParams.applicationTargetDate = $event)),
                  value: 0,
                  name: "applicationTargetDate",
                  type: "radio",
                  class: "h-4 w-4 border-gray-300 focus:from-black mr-3 text-green-500 radio",
                  checked: ""
                }, null, 512), [
                  [_vModelRadio, _ctx.searchParams.applicationTargetDate]
                ]),
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t('monthDesignation')), 1)
              ]),
              _createVNode("div", null, [
                _createVNode(_component_DatePicker, {
                  width: "120",
                  type: "month",
                  disabled: _ctx.searchParams.applicationTargetDate !== 0
                }, null, 8, ["disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("label", _hoisted_22, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchParams.applicationTargetDate = $event)),
                  value: 1,
                  name: "applicationTargetDate",
                  type: "radio",
                  class: "h-4 w-4 border-gray-300 focus:ring-2 focus:focus-radio mr-3 radio"
                }, null, 512), [
                  [_vModelRadio, _ctx.searchParams.applicationTargetDate]
                ]),
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.t('specifyThePeriod')), 1)
              ]),
              _createVNode("div", null, [
                _createVNode(_component_DatePicker, {
                  width: "240",
                  type: "date",
                  "is-range": "",
                  format: "YYYY/MM/DD",
                  disabled: _ctx.searchParams.applicationTargetDate !== 1
                }, null, 8, ["disabled"])
              ])
            ]),
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.t('workingStyle')), 1),
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_Select, {
                "options-select": _ctx.workingStyleOption,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ]),
            _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('affiliationOrganization')), 1),
            _createVNode("div", _hoisted_27, [
              _createVNode(_component_Select, {
                "options-select": _ctx.organizationOption,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ]),
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.t('dailyAttendanceHeaders.organization')), 1),
            _createVNode("div", _hoisted_29, [
              _createVNode(_component_Select, {
                "options-select": _ctx.directorOption,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ]),
            _createVNode("div", _hoisted_30, _toDisplayString(_ctx.t('director')), 1),
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_Select, {
                "options-select": _ctx.attributeOption,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ]),
            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.t('applicationApprovalContent.attribute')), 1),
            _createVNode("div", _hoisted_33, [
              _createVNode(_component_Select, {
                "options-select": _ctx.allAttributes,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ]),
            _createVNode("div", _hoisted_34, _toDisplayString(_ctx.t('fullName')), 1),
            _createVNode("div", _hoisted_35, [
              _createVNode(_component_Input, {
                "icon-search": true,
                "options-select": _ctx.allAttributes,
                "item-text": "text",
                "model-value": "0"
              }, null, 8, ["options-select"])
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode(_component_Button, { class: "btn-light-blue h-10 w-20 mb-2" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["isSelect"])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", _hoisted_38, [
        _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('operateOnAllChecked')) + ": ", 1),
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_Button, {
            class: "mr-2 btn-light-blue w-32 h-10",
            size: "large"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('approve')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "mr-10 btn-red w-32 h-10",
            size: "large"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('reject')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_41, [
        _createVNode("span", _hoisted_42, _toDisplayString(_ctx.t('applicationApprovalContent.applicationTypeDisplaySelection')) + ":", 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionsRadioDefault, (item, index) => {
          return (_openBlock(), _createBlock(_component_Checkbox, {
            "option-checkbox": { label: item.label },
            key: index,
            label: item.label,
            value: item.value,
            classes: "pr-6"
          }, null, 8, ["option-checkbox", "label", "value"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_43, [
        _createVNode(_component_Button, { class: "btn-light-blue h-10 w-200px" }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t('export')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_44, [
      _createVNode(_component_Table, {
        headers: _ctx.applicationHeaders,
        data: _ctx.applicationData,
        "show-select": "",
        "selected-item": _ctx.applicationSelected,
        "onUpdate:selected-item": _cache[8] || (_cache[8] = ($event: any) => (_ctx.applicationSelected = $event))
      }, {
        applicant: _withId(({ item }) => [
          _createVNode("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _createVNode(_component_Avatar, {
                width: "40px",
                height: "40px",
                src: item.avatar,
                class: "mr-2"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_47, [
              _hoisted_48,
              _hoisted_49,
              _createVNode("div", _hoisted_50, [
                _createVNode("div", null, [
                  _createVNode("span", null, _toDisplayString(item.applicant), 1),
                  _hoisted_51,
                  _hoisted_52
                ]),
                _hoisted_53
              ]),
              _hoisted_54
            ])
          ])
        ]),
        applicationDate: _withId(({ item }) => [
          _createVNode("div", _hoisted_55, [
            _createVNode("div", null, _toDisplayString(item.applicationDate), 1),
            _createVNode("div", null, _toDisplayString(item.applicationDateTime), 1),
            _createVNode("div", _hoisted_56, [
              _hoisted_57,
              _createVNode("span", _hoisted_58, _toDisplayString(_ctx.t('applicationApprovalContent.subsequentApplication')), 1)
            ])
          ])
        ]),
        application_title: _withId(({ item }) => [
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode("p", null, _toDisplayString(item.application_title), 1),
              _createVNode("div", _hoisted_61, [
                _createVNode("span", {
                  class: "box-tag flex justify-end font-bold font-size-10 h-5",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addTargetApplicationPopup && _ctx.addTargetApplicationPopup(...args)))
                }, _toDisplayString(_ctx.t('applicationApprovalContent.detailApplication')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _hoisted_63,
              _hoisted_64,
              (!item.application_title_has)
                ? (_openBlock(), _createBlock("div", _hoisted_65, [
                    _hoisted_66,
                    _hoisted_67,
                    _hoisted_68,
                    _hoisted_69
                  ]))
                : _createCommentVNode("", true),
              (!item.application_title_has)
                ? (_openBlock(), _createBlock("div", _hoisted_70, [
                    _hoisted_71,
                    _hoisted_72,
                    _hoisted_73,
                    _hoisted_74
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        final_appointer: _withId(({ item }) => [
          _createVNode("div", _hoisted_75, [
            _createVNode(_component_Avatar, {
              width: "40px",
              height: "40px",
              src: item.avatar,
              class: "mr-2"
            }, null, 8, ["src"]),
            _createVNode("div", null, _toDisplayString(item.final_appointer), 1)
          ])
        ]),
        target_date: _withId(() => [
          _createVNode("div", _hoisted_76, [
            _createVNode(_component_Button, { class: "btn-light-blue h-8 w-1/2 mr-2" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('approve')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, { class: "btn-red h-8 w-1/2 rl-2" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('reject')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Input, {
            classes: "bg-gray",
            placeholder: _ctx.t('enterAdministratorComment')
          }, null, 8, ["placeholder"])
        ]),
        next_approver: _withId(({ item }) => [
          _createVNode("div", _hoisted_77, [
            _createVNode("span", null, _toDisplayString(item.next_approver), 1)
          ])
        ]),
        application_message: _withId(({ item }) => [
          _createVNode("div", _hoisted_78, [
            _createVNode("div", null, _toDisplayString(item.application_message), 1)
          ])
        ]),
        target_date1: _withId(({ item }) => [
          _createVNode("div", _hoisted_79, [
            _createVNode("div", _hoisted_80, _toDisplayString(_ctx.handleYear(item.target_date1)), 1),
            _createVNode("div", _hoisted_81, [
              _createVNode("span", _hoisted_82, _toDisplayString(_ctx.handleMonth(item.target_date1)), 1),
              _hoisted_83
            ]),
            _createVNode("div", _hoisted_84, [
              _createVNode("span", {
                class: "font-bold font-size-10 h-5",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addTargetApplicationPopup && _ctx.addTargetApplicationPopup(...args)))
              }, _toDisplayString(_ctx.t('applicationApprovalContent.detailApplication')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "selected-item"])
    ]),
    _createVNode(_component_ModalApplicationApproval, {
      modelValue: _ctx.isShowApplicationPopup,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowApplicationPopup = $event)),
      onOnClose: _ctx.closeAddTargetApplicationPopup
    }, null, 8, ["modelValue", "onOnClose"])
  ]))
})